import * as React from "react";
import { FastField } from "formik";
import { posNumberonChange } from "./utils";
import { Checkbox, ColorPicker, FieldOpeningHoursV2, FormGroup, SelectServices, Switch } from "@lib/components";
import { Input } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { inject, observer } from "mobx-react";
import { ModalContent } from "@lib/components";
import { Modal } from "@lib/components";
import { TabSelect, SelectAdv, FieldOpeningHours } from "@lib/components";
import {
  CoreUtils,
  DataLocales,
  getId,
  ListOrderTimesOptions,
  ListServicesOptionsNoB,
  RestaurantUtils,
} from '@lib/common';
import _cloneDeep from "lodash/cloneDeep";
import { MobxComponent } from "../../../../../mobx/components";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { MenuItemText } from "../menus/layout/floating-button";
import { IconDelete, IconGreenEllipse, IconHelp, IconRedEllipse } from "../../../../components/v2/icons";
import { SettingsFormGroup, SettingsFormGroupInput, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsFormInputContainer, SettingsSwitchContainer, SettingsActionButtonContainer, SettingsActionButtonWrapper, OptionalText } from "../settings-v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { MenuActionContainer, MenuActionItem, MenuColorBodyWrapper, MenuColorColorPickerText, MenuColorColorPickerWrapper, MenuColorDescription, MenuColorFormGroup, MenuColorLabel, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuPublishPlatformContainer, MenuServiceTypeContainer, MenuServiceTypeItem, MenuToggleContainer, MenuToggleText } from "../../../../components/v2/layout.c";
import { PRESET_COLORS } from "../../../../components/v2/menucolor";
import type { AffectedEntityRow, OverrideChangesSummary } from "../../../../components/v2/menupreoverride";
import { runOnceNotification } from "../../../../utils/run_once_notification";
import { UI } from "../../../../../core/ui";
import { cloneDeep, isEmpty, isObject } from "lodash";
import { POS_PRINTERS } from "../../../../components/v2/data";
import { toJS } from "mobx";
import shortid from "shortid";
import { MenuPresence } from "../../../../components/menu-presence";

function menuDefinesPosOnlineBlocks(conditions: any): {
	defines: boolean;
	pos: any;
	online: any;
} {
	const sourcePos = conditions?.pos;
	const sourceOnline = conditions?.online;
	const defines =
		(sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0) ||
		(sourceOnline != null && typeof sourceOnline === "object" && Object.keys(sourceOnline).length > 0);
	return { defines, pos: sourcePos, online: sourceOnline };
}

function mergeAvailabilityWithPosOnline(resolved: any, sourcePos: any, sourceOnline: any): any | null {
	const base = resolved && typeof resolved === "object" ? cloneDeep(resolved) : {};
	let changed = false;

	const parentHasPos =
		sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0;
	const parentHasOnline =
		sourceOnline != null &&
		typeof sourceOnline === "object" &&
		Object.keys(sourceOnline).length > 0;

	if (parentHasPos && (resolved == null || resolved.pos === undefined || resolved.pos === null)) {
		base.pos = cloneDeep(sourcePos);
		changed = true;
	}
	if (
		parentHasOnline &&
		(resolved == null || resolved.online === undefined || resolved.online === null)
	) {
		base.online = cloneDeep(sourceOnline);
		changed = true;
	}

	return changed ? base : null;
}

type FormValues =
	T.Schema.Restaurant.Menu.RestaurantCategory |
	T.Schema.Restaurant.Menu.RestaurantCategoryV2;

interface Props {
	type: "edit" | "create";
	menuIndex: number;
	initialValues: FormValues | null;
	close: () => void;
	v2VisibilityDelegate?: (args: {
		entity: 'menu' | 'category';
		menuIndex: number;
		menuId: string;
		categoryId?: string;
		categoryIndex?: number;
		nextConditions: any;
		entityName: string;
	}) => Promise<boolean>;
	onReceiptPrinterCategoryConflict?: (payload: {
		menuIndex: number;
		menuId: string;
		categoryId: string;
		categoryName: string;
		itemIds: string[];
		selectedPrinterIds: string[];
		affectedEntities: AffectedEntityRow[];
		changesSummary: OverrideChangesSummary;
	}) => void;
	v2PrintersDelegate?: (args: {
		entity: 'menu' | 'category';
		menuIndex: number;
		menuId: string;
		categoryId?: string;
		categoryIndex?: number;
		nextPosPrinters: readonly any[];
		entityName: string;
	}) => Promise<boolean>;
}

interface State {
	tab: string;
	color: string;
	/** Printer _ids selected for this category (eligible items); state-only until v2 endpoint exists */
	selectedPrinterIdsForEligible: string[];
	printerStatusById: Record<string, T.API.DashboardPrinterStatusResItem>;
}

/** The id of whatever this editor has open, in either menu schema. */
function presenceEntityId(initialValues: any): string | undefined {
	return initialValues?.id || initialValues?._id || undefined;
}

function MenuPresenceBar(props: { entityId?: string }) {
	return (
		<div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 4px 8px' }}>
			<MenuPresence scope="current-menu" entityId={props.entityId} />
		</div>
	);
}

@inject("store") @observer
export class RestaurantFormCategoryV2 extends MobxComponent<Props, State> {

	constructor(props: Props) {
		super(props);
		this.state = {
			tab: "0",
			color: '#000',
			selectedPrinterIdsForEligible: [],
			printerStatusById: {},
		};
	}

	setTab = (tab: string) => {
		this.setState({ tab });
	};

  componentDidMount() {
    const presenceInitial = this.props.initialValues as { id?: string; _id?: string; name?: string } | null;
    const presenceId = presenceInitial?.id || presenceInitial?._id;
    if (presenceId) {
      this.injected.store.notifications.menuPresenceSetEntity('category', presenceId, presenceInitial?.name || null);
    }

    const r = this.injected.store.restaurant!;
    if (r?.settings?.printers) {
      // @ts-ignore
      const assignedPrinterIds = RestaurantUtils.menu.getAssignPrintersByTypeV2(r, 'category', this.props.initialValues?.id || '');
      this.setState({ selectedPrinterIdsForEligible: assignedPrinterIds });
			this.loadPrinterStatus();
    }
  }


	componentWillUnmount() {
		this.injected.store.notifications.menuPresenceClearEntity();
	}

  componentDidUpdate(prevProps: Props) {
  	const prevPresenceId = presenceEntityId(prevProps.initialValues);
  	const nextPresenceId = presenceEntityId(this.props.initialValues);
  	if (prevPresenceId !== nextPresenceId) {
  		if (nextPresenceId) {
  			this.injected.store.notifications.menuPresenceSetEntity(
  				'category', nextPresenceId, (this.props.initialValues as any)?.name || null);
  		} else {
  			this.injected.store.notifications.menuPresenceClearEntity();
  		}
  	}

		if (this.props.initialValues && !prevProps.initialValues) {
			this.setTab("0");
			this.loadPrinterStatus();
		}
	}

	loadPrinterStatus = async () => {
		try {
			const { store } = this.injected;
			const r = store.restaurant;
			if (!r?.settings?.printers?.length) return;
			const res = await store.api.printer_status({
				restaurant_id: r._id,
				printers: r.settings.printers.map((p: any) => p._id),
			});
			if (res.outcome) return;
			const printerStatusById: Record<string, T.API.DashboardPrinterStatusResItem> = {};
			for (const item of res.status || []) {
				printerStatusById[item.printerId] = item;
			}
			this.setState({ printerStatusById });
		} catch {
			// ignore status fetch errors
		}
	};

	assignPrinterToCategory = (printer: any) => {
		this.setState((s) => ({
			selectedPrinterIdsForEligible: s.selectedPrinterIdsForEligible.includes(printer._id)
				? s.selectedPrinterIdsForEligible.filter((id) => id !== printer._id)
				: [...s.selectedPrinterIdsForEligible, printer._id]
		}))
	}

	render() {
		const { type, close } = this.props;
		const { tab } = this.state;
		const { store } = this.injected;
		const { activeMobileMenu } = store;
		const activePrinters = store.ably.printers;


		const initialValues = _cloneDeep(this.props.initialValues);
		//@ts-ignore
		if (initialValues && !initialValues.conditions) {
			//@ts-ignore
			initialValues.conditions = {
				hide_unavailable_category: false,
				services: [],
				hours: [],
			};
		}

		let openItems = false;
		let openItemsList: any = [];
		const r = this.injected.store.restaurant;
		// console.log(1)
		if (r && initialValues) {
			// console.log(2)
			// console.log({ initialValues });
			// const filteredMenus = r.menus.filter((menu: any) => menu._id === initialValues.menu_id);
			// if (filteredMenus.length > 0) {
			if (
				// filteredMenus[0]
				// && typeof filteredMenus[0].abacus_open_items === "boolean"
				// && filteredMenus[0].abacus_open_items === true
				r.abacus
				&& typeof r.abacus.abacus_open_items === "boolean"
				&& r.abacus.abacus_open_items === true
			) {
				// console.log(3)
				openItems = true;
				if (
					// filteredMenus[0]
					// && filteredMenus[0].abacus_open_item_list
					r.abacus.abacus_open_item_list
					&& r.abacus.abacus_open_item_list.length > 0
				) {
					// console.log(4)
					const filteredList = r.abacus.abacus_open_item_list.filter(openItem => !['Online Promos', 'Online Fees', 'Online Tips'].includes(openItem.productName))
					openItemsList = filteredList.map(openItemListItem => {
						return {
							value: openItemListItem.productId,
							label: openItemListItem.productName
						}
					});
				}
			}
			// }
		}
		// console.log({ openItems });
		//
		const menuTabs = openItems
			? [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
				{ label: "Open Items", value: "2" },
			]
			: (r?.wpos?.wpos_status ? [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
				{ label: "POS", value: "3" },
			] : [
				{ label: "General", value: "0" },
				{ label: "Conditions", value: "1" },
			]);
		//
		return (
					<>
					{(activeMobileMenu.name === 'create-category' || activeMobileMenu.name === 'edit-category') &&
					 <TabGroup className='menus'>

						<TabItem
							active={this.state.tab === '0'}
							onClick={() => this.setState({ tab: '0' })}

						>
							General
						</TabItem>
						<TabItem
							active={this.state.tab === '1'}
							onClick={() => this.setState({ tab: '1' })}

						>
							Conditions
						</TabItem>
						<TabItem
							active={this.state.tab === '2'}
							onClick={() => this.setState({ tab: '2' })}

						>
							Open Items
						</TabItem>
						<TabItem
							active={this.state.tab === '3'}
							onClick={() => this.setState({ tab: '3' })}

						>
							POS
						</TabItem>
					</TabGroup>}
					<RestaurantForm<FormValues>
				submit={async (r: any, values: FormValues): Promise<{ r: any; update: { $set: { menus: any[] } } }> => {
					const { menuIndex } = this.props;

					r.menus = r.menus || [];
					r.menus[menuIndex] = r.menus[menuIndex] || { categories: [] };
					r.menus[menuIndex].categories = r.menus[menuIndex].categories || [];

					//@ts-ignore
					const printers = values.integrations?.pushpos.printers || [];

					if(printers.length > 0 ) { //propagate dishes / items
						//@ts-ignore
						values.dishes = values.dishes.map(d => {
							//@ts-ignore
							let dpushpos = d.integrations?.pushpos || {};
							if(isEmpty(dpushpos)) {
								return {
									...d,
									integrations: {
										pushpos: {
											...dpushpos,
											printers: printers
										}
									},
								};
							} return d;

						})
					}

					//@ts-ignore
					const existingIndex = r.menus[menuIndex].categories.findIndex((p: FormValues) => p._id === values._id);
					if (existingIndex === -1) {
						r.menus[menuIndex].categories.push(values);
					} else {
						r.menus[menuIndex].categories[existingIndex] = values;
					}

					const update = { $set: { menus: r.menus } };
					return { r, update };
				}}
				customSubmit={
					store.isNewMenuSchema ?
					async (values, form) => {
						const { menuIndex } = this.props;
						const r = this.injected.store.restaurant!;
						const targetMenus = store.isNewMenuSchema ? (r.menus_v2 || []) : r.menus;
						const targetMenu = targetMenus[menuIndex];
						let copyValues = cloneDeep(values);

						//@ts-ignore
						copyValues = {
							...copyValues,
							name: values.name,
							description: values.description,
              				display_name: values.display_name
						}

						//@ts-ignore
						const printers = copyValues?.integrations?.pushpos.printers || [];
						//@ts-ignore
						const categoryConditionsBeforeApi = values.conditions;
						const { defines: categoryDefinesPosOnline, pos: catSourcePos, online: catSourceOnline } =
							menuDefinesPosOnlineBlocks(categoryConditionsBeforeApi);

						try {
							//@ts-ignore
							const existingIndex = targetMenu.categories.findIndex(c => getId(c) === getId(values));
							if ( existingIndex === -1 ) {

								if(store.isNewMenuSchema) {
									// v2 API: conditions → availability, strip client-only fields
									//@ts-ignore
									copyValues.availability = values.conditions;
									//@ts-ignore
									delete copyValues.conditions;
									//@ts-ignore
									delete copyValues.availabilities;
									//@ts-ignore
									delete copyValues._metadata as any;
								}

								const res = await store.api.menu_create_category({
									restaurant_id: r._id,
									menu_id: getId(targetMenu),
									data: copyValues
								});

								if(printers.length > 0 ) { //propagate to items/dishes
									const menuId = getId(targetMenu);
									const categoryId = getId(res);
                  const itemsToUpdate: any[] = []
                  // @ts-ignore
                  targetMenu.items
                    .filter((i: any) => i.category_id === categoryId)
                    .forEach((d: any) => {
                      let dpushpos = d.integrations?.pushpos || {};
                      if(isEmpty(dpushpos)) {
                        itemsToUpdate.push({
                          menu_id: menuId,
                          category_id: categoryId,
                          id: getId(d),
                          integrations: {
                            pushpos: { ...dpushpos, printers: printers }
                          }
                        })
                      }
                    })
                  await store.api.menu_partial_update_batch_items({
                    restaurant_id: r._id,
                    data: { items: itemsToUpdate },
                  })
								}

								if (categoryDefinesPosOnline && store.isNewMenuSchema) {
									//@ts-ignore
									const newCatAvailId =
										(res as any)?.availability_id ?? categoryConditionsBeforeApi?.id;
									if (newCatAvailId) {
										const menuId = getId(targetMenu);
										const categoryId = getId(res);
                    // @ts-ignore
                    const availabilitiesMap = new Map((targetMenu.availabilities || []).map((a: any) => [a.id, a]));
                    // @ts-ignore
                    const itemsToUpdate = targetMenu.items
                      .filter((i: any) => i.category_id === categoryId)
                      .map((d: any) => {
                        const itemAid = d.availability_id || newCatAvailId;
                        if (itemAid === newCatAvailId) return null;
                        //@ts-ignore
                        const resolved = availabilitiesMap.get(itemAid)
                        const mergedAvail = mergeAvailabilityWithPosOnline(
                          resolved,
                          catSourcePos,
                          catSourceOnline
                        );
                        if (mergedAvail == null) return null;
                        return {
                          menu_id: menuId,
                          category_id: categoryId,
                          id: getId(d),
                          availability: mergedAvail,
                          availability_id: itemAid,
                        }
                      }).filter(Boolean);
                    if (itemsToUpdate.length > 0) {
                      await store.api.menu_partial_update_batch_items({
                        restaurant_id: r._id,
                        data: { items: itemsToUpdate },
                      })
                    }
									}
								}
								UI.notification.success("Category added");
							} else {
								if(store.isNewMenuSchema) {
									// v2 API: conditions → availability, availability_id; strip client-only fields
									//@ts-ignore
									copyValues.availability = values.conditions;
									//@ts-ignore
									copyValues.availability_id = values.conditions?.id;
									//@ts-ignore
									delete copyValues.conditions;
									//@ts-ignore
									delete copyValues.availabilities;
									//@ts-ignore
									delete copyValues._metadata as any;

									//@ts-ignore
									if(!copyValues.media_url || copyValues.media_url === '') {
										//@ts-ignore
										delete copyValues.media_url;
									}
								}

								const conditions = (values as any).conditions;
								const categoryItemIds = ((targetMenu as any).items || [])
									.map((i: any) => i.category_id === getId(values) ? getId(i) : null)
									.filter((id: any) => id !== null);
								const receiptPrinters = r.settings?.printers ?? [];
								const selectedPrinterIds = [...this.state.selectedPrinterIdsForEligible].sort();
								const selectedKey = selectedPrinterIds.join('\0');
								let receiptConflictCount = 0;
								for (const itemId of categoryItemIds) {
									const currentKey = RestaurantUtils.menu
										.receiptPrinterIdsAssigningItem(receiptPrinters, itemId)
										.slice()
										.sort()
										.join('\0');
									if (currentKey !== selectedKey) receiptConflictCount++;
								}
								const shouldDeferReceiptOverride =
									store.isNewMenuSchema &&
									categoryItemIds.length > 0 &&
									receiptConflictCount > 0 &&
									!!this.props.onReceiptPrinterCategoryConflict;
								if (shouldDeferReceiptOverride && this.props.onReceiptPrinterCategoryConflict) {
									const nameById = (id: string) =>
										(receiptPrinters as { _id?: string; name?: string }[]).find((p) => p._id === id)?.name ?? id;
									const selectedNames = selectedPrinterIds.map(nameById);
									const affectedEntities: AffectedEntityRow[] = [];
									for (const itemId of categoryItemIds) {
										const curIds = RestaurantUtils.menu
											.receiptPrinterIdsAssigningItem(receiptPrinters, itemId)
											.slice()
											.sort();
										if (curIds.join('\0') === selectedKey) continue;
										const it = (targetMenu as { items?: { id?: string; name?: string }[] }).items?.find((x: any) => getId(x) === itemId);
										affectedEntities.push({
											entityType: 'item',
											id: itemId,
											name: (it as { name?: string } | undefined)?.name ?? String(itemId).slice(0, 8),
											printers: {
												from: curIds.map(nameById),
												to: selectedNames,
											},
										});
									}
									const changesSummary: OverrideChangesSummary = {
										printers: {
											from: [
												`${affectedEntities.length} item(s) use different receipt printers than this category selection`,
											],
											to: selectedNames.length ? selectedNames : ['—'],
										},
									};
									this.props.onReceiptPrinterCategoryConflict({
										menuIndex,
										menuId: getId(targetMenu),
										categoryId: getId(values),
										categoryName: (values as { name?: string }).name ?? '',
										itemIds: categoryItemIds,
										selectedPrinterIds: [...selectedPrinterIds],
										affectedEntities,
										changesSummary,
									});
									form.setSubmitting(false);
									return;
								}
								const nextPosPrinters = ((values as any)?.integrations?.pushpos?.printers ??
									[]) as any[];
								const currentCategoryRow = targetMenu.categories?.[existingIndex];
								const currentPosPrinters = ((currentCategoryRow as any)?.integrations?.pushpos?.printers ??
									[]) as any[];
								const nextCategoryColor = (values as any)?.color;
								const currentCategoryColor = (currentCategoryRow as any)?.color;
								const categoryColorChanged =
									JSON.stringify(nextCategoryColor ?? null) !==
									JSON.stringify(currentCategoryColor ?? null);
								const nextPosColor = (values as any)?.integrations?.pushpos?.color;
								const currentPosColor = (currentCategoryRow as any)?.integrations?.pushpos?.color;
								const posColorChanged =
									JSON.stringify(nextPosColor ?? null) !==
									JSON.stringify(currentPosColor ?? null);
								const currentCategoryAvailId = currentCategoryRow
									? ((currentCategoryRow as any)?.availability_id || (targetMenu as any)?.availability_id)
									: undefined;
								const currentCategoryAvail = currentCategoryAvailId
								// @ts-ignore
									? (targetMenu.availabilities || []).find((a: any) => a.id === currentCategoryAvailId)
									: null;
								const visibilityChanged =
									JSON.stringify((currentCategoryAvail as any)?.pos ?? null) !==
										JSON.stringify((conditions as any)?.pos ?? null) ||
									JSON.stringify((currentCategoryAvail as any)?.online ?? null) !==
										JSON.stringify((conditions as any)?.online ?? null) ||
									JSON.stringify((currentCategoryAvail as any)?.external_platforms ?? null) !==
										JSON.stringify((conditions as any)?.external_platforms ?? null);
								const printersChanged =
									JSON.stringify([...currentPosPrinters].sort()) !==
									JSON.stringify([...nextPosPrinters].sort());
								const selectedEligiblePrinterIds = this.state.selectedPrinterIdsForEligible || [];
								const categoryInheritsMenuAvailability =
									!((currentCategoryRow as any)?.availability_id) ||
									(currentCategoryRow as any)?.availability_id === (targetMenu as any)?.availability_id;
								if (store.isNewMenuSchema && categoryInheritsMenuAvailability && currentCategoryAvail) {
									const newAvailId = shortid.generate();
									const forkedAvailability = {
										...cloneDeep(currentCategoryAvail),
										...cloneDeep(conditions),
										id: newAvailId,
									};
									const nextAvailabilities = [...(((targetMenu as any).availabilities || []) as any[]), forkedAvailability];
									await store.api.menu_partial_update_menu({
										restaurant_id: r._id,
										menu_id: getId(targetMenu),
										data: { availabilities: nextAvailabilities },
									});
									(targetMenu as any).availabilities = nextAvailabilities;
									// @ts-ignore
									copyValues.availability = forkedAvailability;
									// @ts-ignore
									copyValues.availability_id = newAvailId;
								}
								if (
									store.isNewMenuSchema &&
									this.props.v2VisibilityDelegate &&
									menuDefinesPosOnlineBlocks(conditions).defines &&
									visibilityChanged
								) {
									const deferred = await this.props.v2VisibilityDelegate({
										entity: 'category',
										menuIndex,
										menuId: getId(targetMenu),
										categoryId: getId(values),
										categoryIndex: existingIndex,
										nextConditions: conditions,
										entityName: (values as any).name || 'Category',
									});
									if (deferred) {
										form.setSubmitting(false);
										return;
									}
								}
								if (
									store.isNewMenuSchema &&
									this.props.v2PrintersDelegate &&
									printersChanged
								) {
									const deferredPrinters = await this.props.v2PrintersDelegate({
										entity: 'category',
										menuIndex,
										menuId: getId(targetMenu),
										categoryId: getId(values),
										categoryIndex: existingIndex,
										nextPosPrinters,
										entityName: (values as any).name || 'Category',
									});
									if (deferredPrinters) {
										form.setSubmitting(false);
										return;
									}
								}

								await store.api.menu_partial_update_category({
									restaurant_id: r._id,
									menu_id: getId(targetMenu),
									category_id: getId(targetMenu.categories[existingIndex]),
									data: copyValues,
								});

								// For the legacy (v1/original) schema, propagate printer
								// settings down to dishes that don't yet have pushpos
								// integrations configured.
								if ( printersChanged ) {
									const menuId = getId(targetMenu);
									const categoryId = getId(targetMenu.categories[existingIndex]);
                  const itemsToUpdate: any[] = []
                  // @ts-ignore
                  targetMenu.items
                    .filter((i: any) => i.category_id === categoryId)
                    .forEach((d: any) => {
                      let dpushpos = d.integrations?.pushpos || {};
                      if (isEmpty(dpushpos)) {
                        itemsToUpdate.push({
                          menu_id: menuId,
                          category_id: categoryId,
                          id: getId(d),
                          integrations: {
                            pushpos: { ...dpushpos, printers },
                          },
                        })
                      }
                    })
                  await store.api.menu_partial_update_batch_items({
                    restaurant_id: r._id,
                    data: { items: itemsToUpdate },
                  })
								}

								if (categoryDefinesPosOnline && visibilityChanged && store.isNewMenuSchema) {
									const catRow = targetMenu.categories[existingIndex];
									const categoryAvailId =
										categoryConditionsBeforeApi?.id ?? (catRow as any)?.availability_id;
									const categoryId = getId(catRow);
									if (categoryAvailId) {
										const menuId = getId(targetMenu);
                    // @ts-ignore
                    const availabilitiesMap = new Map((targetMenu.availabilities || []).map((a: any) => [a.id, a]));
                    // @ts-ignore
                    const itemsToUpdate = targetMenu.items
                      .filter((i: any) => i.category_id === categoryId)
                      .map((d: any) => {
                        const itemAid = d.availability_id || categoryAvailId;
                        if (itemAid === categoryAvailId) return null;
                        //@ts-ignore
                        const resolved = availabilitiesMap.get(itemAid)
                        const mergedAvail = mergeAvailabilityWithPosOnline(
                          resolved,
                          catSourcePos,
                          catSourceOnline
                        );
                        if (mergedAvail == null) return null;
                        return {
                          menu_id: menuId,
                          category_id: categoryId,
                          id: getId(d),
                          availability: mergedAvail,
                          availability_id: itemAid,
                        }
                      }).filter(Boolean);
                    if (itemsToUpdate.length > 0) {
                      await store.api.menu_partial_update_batch_items({
                        restaurant_id: r._id,
                        data: { items: itemsToUpdate },
                      })
                    }
									}
								}
								UI.notification.success("Category updated");
							}
              // @ts-ignore
              const itemIds = targetMenu.items.map((i: any) => i.category_id === getId(values) ? getId(i) : null).filter((id: any) => id !== null);
              const shouldUpdateReceiptEligibility =
                JSON.stringify([...this.state.selectedPrinterIdsForEligible].sort()) !==
                JSON.stringify(
                  (
                    RestaurantUtils.menu.getAssignPrintersByTypeV2(
                      r,
                      'category',
                      getId(values)
                    ) || []
                  ).slice().sort()
                );
              if (itemIds.length && shouldUpdateReceiptEligibility) {
                const { updatedPrinters, updateQuery } = RestaurantUtils.menu.assignItemsToPrinterV2(r, itemIds, this.state.selectedPrinterIdsForEligible);
                await store.api.restaurant_update({
                  _id: r._id,
                  update: updateQuery
                })
                r.settings.printers = updatedPrinters;
                store.setRestaurant({ ...r });
              }

							if (store.isNewMenuSchema && r._id) {
								try {
									const got = await store.api.menu_get_menus(r._id);
									if (got?.menus) {
										await store.updateRestaurant({ menus_v2: got.menus });
									}
								} catch {
									/* best-effort */
								}
							}

							store.setActiveMobileMenu(
								store.activeMobileMenu.referrer.pop()!,
								Array.from(new Set(store.activeMobileMenu.referrer))
							);
							form.setSubmitting(false);
						} catch (e) {
							UI.notification.error(e?.error ?? e?.message ?? 'An error occurred');
							form.setSubmitting(false);
						}
					} : undefined
				}
				validators={{
					name: (values) => {
						if (!values.name) return { name: "This field is required" };
					},
				}}
				initialValues={initialValues}
				onSuccess={() => {
					store.setActiveMobileMenu(
						store.activeMobileMenu.referrer.pop()!,
						Array.from(new Set(store.activeMobileMenu.referrer))
					)
					close()
				}}
				onSuccessMessage={type === "edit" ? "Category edited" : "Category created"}
			>
					{({ form, error, getFieldError }) => {
						const { isSubmitting, setFieldValue } = form;
						const { store } = this.injected;
						const nameValue = form.values.name;
						const descValue = form.values.description;
           				 const displayNameValue = form.values.display_name;

						//@ts-ignore
						const currentAssignPOSPrinters = form.values?.integrations?.pushpos?.printers || [] as number[];

						// option_sets_v2 is where this layout's option sets live once the menu API
						// serves them; the legacy array is empty for those restaurants.
						//
						// Single-select only: PushPOS holds one such choice per item row. The translator
						// reports a multi-select one anyway, in case the field is set some other way.
						const premodifierSets: any[] = store.isNewMenuSchema
							? (store.restaurant?.option_sets_v2 || [])
							: ((store.restaurant && store.restaurant.option_sets) || []);
						const premodifierOptions = premodifierSets
							.filter((set) => !set.conditions?.multi_select)
							.map((set) => ({ label: set.name, value: set.id || set._id }));

						runOnceNotification(error)
						return (
							<div>
								<MenuPresenceBar entityId={presenceEntityId(this.props.initialValues)} />
								{this.state.tab === '0' && <>
									<SettingsFormGroup>
										<SettingsFormGroupInput
											 error={(error && getFieldError(form, 'name')) || null}
											 >
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="name"
													render={({ field }: any) => (
														<input
															type="text"
															required
															{...field}
															value={nameValue}
															/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Display Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="display_name"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
                              value={displayNameValue}/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Description</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
													<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="description"
													render={({ field }: any) => (
														<input
															type="text"
															{...field}
															value={descValue}
															/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										{store.isNewMenuSchema && <>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>This group will be active on<OptionalText>(Required)</OptionalText></SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorFormGroup>
												<MenuColorLabel>POS</MenuColorLabel>
												<MenuToggleContainer>
													<FastField
														name="conditions.pos.enabled"
														render={({ field }: any) => (
													<Switch
														id="pos-enabled"
														checked={field.value}
														onChange={(e) => setFieldValue('conditions.pos.enabled', e.target.checked)}
													/>) } />
												</MenuToggleContainer>
											</MenuColorFormGroup>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorLabel>Select Service Type</MenuColorLabel>
											<SettingsFormInputContainer>
												<FastField
												name="conditions.pos.services"
												render={({ field }: any) => (
													<SelectServices
													type="multi"
													value={field.value || []}
													onChange={(
														options: string[]
													) => {
														setFieldValue(
															"conditions.pos.services",
															options
														);
													}}

													options={ListServicesOptionsNoB}/>
												)} />
											</SettingsFormInputContainer>

										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorFormGroup>
												<MenuColorLabel>Online</MenuColorLabel>
												<MenuToggleContainer>
													<FastField
														name="conditions.online.enabled"
														render={({ field }: any) => (
													<Switch
														id="online-enabled"
														checked={field.value}
														onChange={(e) => setFieldValue('conditions.online.enabled', e.target.checked)}
													/>) } />
												</MenuToggleContainer>
											</MenuColorFormGroup>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorLabel>Select Service Type </MenuColorLabel>
											<SettingsFormInputContainer>
												<FastField
												name="conditions.online.services"
												render={({ field }: any) => (
													<SelectServices
													type="multi"
													value={field.value || []}
													onChange={(
														options: string[]
													) => {
														setFieldValue(
															"conditions.online.services",
															options
														);
													}}

													options={ListServicesOptionsNoB}/>
												)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>

										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Assign printer for this category</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											{r!.settings.printers.length > 0 ?
											r?.settings.printers.map(printer => (
											<MenuActionContainer key={printer._id}>
													<MenuActionItem
													onClick={() => this.assignPrinterToCategory(printer)}
													className="menu-printer-item">
													<div className='printer-checkbox'>
														<Checkbox
															id={printer._id}
															checked={this.state.selectedPrinterIdsForEligible.includes(printer._id)}
															onChange={() => this.assignPrinterToCategory(printer)}
															onClick={(e) => e.stopPropagation()}
														/>
														{printer.name}
													</div>

													{(() => {
														const printerStatus = this.state.printerStatusById[printer._id];
														const connected =
															!printer.disabled &&
															(printerStatus
																? !!printerStatus.online
																: activePrinters.indexOf(printer.api_key) !== -1);
														return connected ? (
															<span>
																<IconGreenEllipse />
																Connected
															</span>
														) : (
															<span>
																<IconRedEllipse />
																Disconnected
															</span>
														);
													})()}

												</MenuActionItem>
											</MenuActionContainer>
											))

											: <p>no printers yet.</p> }
										</SettingsFormGroupInput>
										{/*<SettingsFormGroupInput>*/}
										{/*	<SettingsFormLabelContainer>*/}
										{/*		<SettingsFormLabelLeftContainer>Publish this category on other platforms</SettingsFormLabelLeftContainer>*/}
										{/*		<SettingsFormLabelRightContainer>*/}
										{/*		<IconHelp />*/}
										{/*		</SettingsFormLabelRightContainer>*/}
										{/*	</SettingsFormLabelContainer>*/}
										{/*	<MenuPublishPlatformContainer>*/}
										{/*		<MenuPublishPlatFormItem>*/}
										{/*			<MenuPublishPlatFormItemHeader>*/}
										{/*				<MenuPublishPlatFormItemHeaderLabel>Uber</MenuPublishPlatFormItemHeaderLabel>*/}
										{/*				<MenuToggleContainer>*/}
										{/*					<MenuToggleText>{*/}
										{/*						//@ts-ignore*/}
										{/*						form.values.external_platforms?.uber?.enabled ? 'On' : 'Off'*/}
										{/*					}</MenuToggleText>*/}
										{/*					<FastField*/}
										{/*						name="conditions.external_platforms.uber.enabled"*/}
										{/*						render={({ field }: any) => (*/}
										{/*					<Switch*/}
										{/*						id="conditions.external_platforms.uber.enabled"*/}
										{/*						checked={field.value}*/}
										{/*						onChange={(e) => setFieldValue('conditions.external_platforms.uber.enabled', e.target.checked)}*/}
										{/*					/>) } />*/}
										{/*				</MenuToggleContainer>*/}
										{/*			</MenuPublishPlatFormItemHeader>*/}
										{/*			/!*<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>*!/*/}
										{/*		</MenuPublishPlatFormItem>*/}
										{/*		<MenuPublishPlatFormItem>*/}
										{/*			<MenuPublishPlatFormItemHeader>*/}
										{/*				<MenuPublishPlatFormItemHeaderLabel>Abacus</MenuPublishPlatFormItemHeaderLabel>*/}
										{/*				<MenuToggleContainer>*/}
										{/*					<MenuToggleText>{*/}
										{/*						//@ts-ignore*/}
										{/*					form.values.external_platforms?.abacus?.enabled ? 'On' : 'Off'*/}
										{/*					}</MenuToggleText>*/}
										{/*					<FastField*/}
										{/*						name="conditions.external_platforms.abacus.enabled"*/}
										{/*						render={({ field }: any) => (*/}
										{/*					<Switch*/}
										{/*						id="conditions.external_platforms.abacus.enabled"*/}
										{/*						checked={field.value}*/}
										{/*						onChange={(e) => setFieldValue('conditions.external_platforms.abacus.enabled', e.target.checked)}*/}
										{/*					/>) } />*/}
										{/*				</MenuToggleContainer>*/}
										{/*			</MenuPublishPlatFormItemHeader>*/}
										{/*			/!*<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>*!/*/}
										{/*		</MenuPublishPlatFormItem>*/}
										{/*	</MenuPublishPlatformContainer>*/}
										{/*</SettingsFormGroupInput>*/}
									</> }

									</SettingsFormGroup>
								</>}
								{this.state.tab === '1' && <>
									<SettingsFormGroup>
										<SettingsSwitchContainer>
											<SettingsFormLabelLeftContainer>
												Hide Unavailable Menu
											</SettingsFormLabelLeftContainer>
											<FastField
												name="conditions.hide_unavailable_menu"
												render={({ field }: any) => (
													<Switch
														id="conditions.hide_unavailable_menu"
														checked={field.value || false}
														onChange={(e) => setFieldValue(
															"conditions.hide_unavailable_menu",
															e.target
																.checked
														)} />
												)} />
										</SettingsSwitchContainer>

										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'conditions.services')) || null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Services</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="conditions.services"
													render={({ field }: any) => (
														<SelectAdv
															type="multi"
															options={ListServicesOptionsNoB}
															value={field.value || []}
															onChange={(options) => setFieldValue("conditions.services", options)} />
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'hours'))|| null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Applicable Hours</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<FastField
												name="conditions.hours"
												render={({ field }: any) => (
													<FieldOpeningHoursV2
													allowNone={true}
													hours={field.value}
													onChange={(opening_hours) => {
														setFieldValue("conditions", {
															//@ts-ignore
															...form.values.conditions,
															hours: opening_hours,
														});
													}}
/>
												)} />
										</SettingsFormGroupInput>
									</SettingsFormGroup>

								</>}

								{this.state.tab === '2' &&
									<div style={{padding: 16}}>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Abacus Open Item</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="abacus_open_item"
													render={({ field }: any) => (
														<SelectAdv
															type="single"
															options={openItemsList}
															value={field.value}
															onChange={(option: string) => setFieldValue("abacus_open_item", option)} />
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
									</div>}
								{this.state.tab === '3' && <>
								<SettingsFormGroup>
									<SettingsFormGroupInput
										error={(error && getFieldError(form, 'integrations.pushpos.category_id')) || null}>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>POS Category ID</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField name="integrations.pushpos.category_id">
												{({ field, form }: any) => (
												<input
													type="number"
													{...field}
													value={field.value ?? ""}
													onChange={posNumberonChange(field, form)}
													/>
												)}
											</FastField>
										</SettingsFormInputContainer>
									</SettingsFormGroupInput>
									<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Assign printer for this category</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										{POS_PRINTERS.map(printer => (
										<MenuActionContainer
											className="condensed"
											key={printer.value.toString()}>
												<MenuActionItem
												onClick={() => {}}
												className="menu-printer-item">
												<div className='printer-checkbox'>
													<Checkbox
														id={printer.value.toString()}
														onChange={(e) => {
															if(e.target.checked) {
																setFieldValue(
																	'integrations.pushpos.printers',
																	Array.from(new Set([...currentAssignPOSPrinters, printer.value ]))
																)
															} else {
																setFieldValue(
																	'integrations.pushpos.printers',
																	currentAssignPOSPrinters.filter( (p: number) => p !== printer.value)
																)
															}
														}}
														checked={currentAssignPOSPrinters.includes(printer.value)}/>
													{printer.label}
												</div>

											</MenuActionItem>
										</MenuActionContainer>
										))}
									</SettingsFormGroupInput>
									<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Premodifier<OptionalText>(Optional)</OptionalText></SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="integrations.pushpos.premodifier_set_id"
												render={({ field }: any) => (
													<SelectAdv
														type="single"
														options={premodifierOptions}
														value={field.value || ""}
														onChange={(option: string) =>
															setFieldValue("integrations.pushpos.premodifier_set_id", option)
														} />
												)} />
										</SettingsFormInputContainer>
										<p className="desc">A choice your staff make before picking a dish — Classic / Thin / Stuffed. Shown above this category's items on the POS only.</p>
									</SettingsFormGroupInput>
									{ store.isNewMenuSchema && <>
									<SettingsFormGroupInput>
										<MenuColorBodyWrapper style={{padding: 0}}>
											<MenuColorDescription>Select a color to represent this menu.</MenuColorDescription>
											<MenuColorFormGroup>
												<MenuColorLabel>Category Color</MenuColorLabel>
												<FastField
												name="integrations.pushpos.color"
												render={({ field }: any) => (
													<MenuColorColorPickerWrapper>
														<ColorPicker
															color={field.value}
															onChange={(color) => setFieldValue('integrations.pushpos.color', '#' + CoreUtils.colors.rgbToHex(color))}/>
														<MenuColorColorPickerText>{field.value}</MenuColorColorPickerText>
													</MenuColorColorPickerWrapper>
												)} />
											</MenuColorFormGroup>
											<MenuColorLabel>Pre-sets</MenuColorLabel>
											<MenuColorPresetsList>
												{PRESET_COLORS.reduce((rows: string[][], color: string, index: number) => {
												if (index % 2 === 0) {
													rows.push([color]);
												} else {
													rows[rows.length - 1].push(color);
												}
												return rows;
												}, []).map((pair: string[], rowIndex: number) => (
												<MenuColorPresetsListItem key={rowIndex}>
													{pair.map((color: string, i: number) => (
													<MenuColorPresetsListItemContent
														key={i}
														style={{ backgroundColor: color }}
														onClick={() => setFieldValue('integrations.pushpos.color', color)}
													>
														<span>{color}</span>
													</MenuColorPresetsListItemContent>
													))}
												</MenuColorPresetsListItem>
												))}

											</MenuColorPresetsList>
										</MenuColorBodyWrapper>
									</SettingsFormGroupInput></> }
								</SettingsFormGroup>
								</>}
								<SettingsActionButtonContainer>
									<SettingsActionButtonWrapper  style={{ left: 0}}>
										<button type="button"
											className="default btn-cancel"
											onClick={() => {
												store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												);
											} }>
											Cancel
										</button>
										<button type="submit" disabled={isSubmitting}>
											{isSubmitting && <RotateLoader size={2} color="white" />}
											{!isSubmitting && "Save"}
										</button>
									</SettingsActionButtonWrapper>
								</SettingsActionButtonContainer>
							</div>
						);
					} }
				</RestaurantForm>
				</>
		);

	}

}
